import { Component, Input } from '@angular/core';
import { GtmService } from '../../services/gtm.service';
import { GTM_PUSH_CATEGORY, GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES } from '../../modeles/variables';

@Component({
  selector: 'app-capsule-conseil',
  templateUrl: './capsule-conseil.component.html',
  styleUrls: ['./capsule-conseil.component.scss'],
  standalone: false
})
export class CapsuleConseilComponent {
  @Input()
  titre?: string;

  @Input()
  titreInfobulle?: string;

  @Input()
  contenuInfobulle?: string;

  @Input()
  appearance = 'rounded-outline';

  @Input()
  isLinesGreaterThan4 = false;

  isFullText: boolean;

  image: number;

  constructor(private readonly _gtm: GtmService) {
    this.initImage();
    this.isFullText = false;
  }

  get hasInfobulle() {
    return !!this.contenuInfobulle;
  }

  initImage() {
    this.image = Math.floor(Math.random() * 7) + 1;
  }

  showFullText() {
    this.isFullText = !this.isFullText;
    this._gtm.pushEvent({
      event: GTM_PUSH_CATEGORY_INTERRACTIONS_PAGES,
      category: GTM_PUSH_CATEGORY,
      label: this.titre,
      action: 'click - conseil et bon a savoir',
      value: 0,
      nonInteraction: false
    });
  }

  getBackgroundImageSource() {
    return {
      desktop: `/capsule-conseil/boite-conseil-bg-${this.image}.jpg`
    };
  }
}
